/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';
import { useEffect } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'semantic-ui-react';
import SocialLinks from '../../components/SocialLinks';

import Icon from '@package/components/Icon';
import { openManageCookies } from 'lgpd.plugin/actions';
import { getFooterLinks } from '../../actions/footer-links';
import Button from '../Button';
import LogoFooterDesktop from '../Logo/LogoFooterDesktop';

const messages = defineMessages({
  copyright: {
    id: '© COP30 Brasil 2025 All rights reserved',
    defaultMessage: '© COP30 Brasil 2025 All rights reserved',
  },
  manageCookies: {
    id: 'Manage cookies',
    defaultMessage: 'Manage cookies',
  },
});

const FooterLinks = ({ links, lang }) => {
  if (!links?.length) return null;

  return (
    <ul className="links">
      {links.map((link, id) => {
        const { [`url_${lang}`]: url, [`label_${lang}`]: label } = link;

        if (!url || !label) return null;

        return (
          <Button href={url} link small key={id}>
            {label}
          </Button>
        );
      })}
    </ul>
  );
};

const Footer = ({ intl }) => {
  const { locale } = intl;
  const lang = toBackendLang(locale);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFooterLinks());
  }, [dispatch]);
  const result = useSelector((state) => {
    return state.footerLinks;
  });

  return (
    <footer className="site-footer">
      <Container>
        <div className="nav-wrapper">
          <LogoFooterDesktop className="logo" />
          <nav className="footer-nav">
            <FooterLinks links={result.data} lang={lang} />
          </nav>
        </div>

        <div className="cookie-container">
          <Button
            link
            onClick={() => {
              dispatch(openManageCookies());
            }}
          >
            <Icon name="cookie" />
            {intl.formatMessage(messages.manageCookies)}
          </Button>
        </div>
      </Container>
      <div className="bottom">
        <SocialLinks />
        <div className="copyright">
          {intl.formatMessage(messages.copyright)}
        </div>
      </div>
    </footer>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
